export default "__VITE_ASSET__DVL$lxPQ__"